import { axios, securityAxios } from '@/utils/axios'
import { getThirdPartLoginHeader } from '@/lib/business'

// 导出交易历史
export function exportTradeHistory(data) {
  return axios.get(`/user/deal/history/export?${data}`)
}

// 获取交易账号
export function getmtaccount(serverId, type) {
  return axios.post(`/user/mtaccount?serverId=${serverId}&type=${type}`, {
    serverId
  })
}

export function getProplist(data) {
  return securityAxios.post('/server/proplist', data)
}

export function getCommission(data) {
  return securityAxios.get('/user/deposit/commission', data, {
    headers: getThirdPartLoginHeader()
  })
}

export function getCommonRate(data) {
  return securityAxios.post('/common/rate', data)
}

export function depositPageInit(type) {
  return axios({
    url: '/user/deposit/pageInit',
    method: 'get',
    params: {
      type: type
    },
    headers: getThirdPartLoginHeader()
  })
}

export function getDepostInaccount(type) {
  return axios({
    url: '/user/deposit/inaccount',
    method: 'get',
    params: {
      type: type
    },
    headers: getThirdPartLoginHeader()
  })
}

export function getMethodSort() {
  return axios({
    url: '/user/deposit/methodSort',
    method: 'get',
    headers: getThirdPartLoginHeader()
  })
}

export function getWithdrawFee(params) {
  return securityAxios({
    url: '/user/withdraw/withdrawFee',
    method: 'post',
    data: {
      ...params
    }
  })
}

export function getWithdrawMethodSort() {
  return securityAxios.get('/user/withdraw/method-sort')
}

export function userBankConfirm(withdraw) {
  return securityAxios({
    url: '/user/bank/confirm',
    method: 'post',
    data: {
      ...withdraw
    }
  })
}

export function demoAccountDeposit(data) {
  // 模拟账号入金
  return securityAxios.post(`/user/deposit/demoSave`, data)
}

export function demoAccountWithdraw(data) {
  // 模拟账号出金
  return securityAxios.post(`/user/withdraw/demoSave`, data)
}

export function getmultilingualVersion(language) {
  return axios.get(`/common/multilingualVersion/latest?language=${language}`)
}
